import React from 'react';
import styled from 'styled-components/macro';
import { useJoinUrl } from 'src/client/components/buttons/JoinButton';
import { useSelector } from 'src/client/redux';
import { DESKTOP, TABLET_PORTRAIT } from 'src/client/constants/mediaQueries';

type PromoInlineBannerImageProps = {
  desktopImage: string;
  mobileImage: string;
  tabletImage: string;
};

export const PromoInlineBanner = () => {
  const { cdnUrl } = useSelector((state) => state.app);
  const [joinHref] = useJoinUrl({ campaign: 'ad-zone-gallery-inline-banner' });

  const desktopImage = `${cdnUrl}/network-promo-banners/gallery_inline.jpg`;
  const tabletImage = `${cdnUrl}/network-promo-banners/gallery_inline_tablet.jpg`;
  const mobileImage = `${cdnUrl}/network-promo-banners/gallery_inline_mobile.jpg`;

  return (
    <BannerWrapper>
      <BannerLink href={joinHref} desktopImage={desktopImage} mobileImage={mobileImage} tabletImage={tabletImage} />
    </BannerWrapper>
  );
};

const BannerWrapper = styled.section`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 20px 0;
`;

const BannerLink = styled.a<PromoInlineBannerImageProps>`
  aspect-ratio: 300 / 80;
  background-image: url(${({ mobileImage }) => mobileImage});
  background-size: contain;
  background-repeat: no-repeat;
  max-width: 300px;
  width: 100%;

  @media ${TABLET_PORTRAIT} {
    aspect-ratio: 720 / 130;
    background-image: url(${({ tabletImage }) => tabletImage});
    max-width: 720px;
  }

  @media ${DESKTOP} {
    aspect-ratio: 980 / 180;
    background-image: url(${({ desktopImage }) => desktopImage});
    max-width: 980px;
  }
`;
